import app from "../_app";

const variants = [...document.querySelectorAll('.js-variant')];

variants.map((variant) => {

    const popup = variant.querySelector('.js-popup');

    if (popup) {
        
        const trigger = variant.querySelector('.js-popup-trigger');
        const closeTriggers = [...variant.querySelectorAll('.js-popup-close')];

        const openImagePopup = e => {

            // app.lockBody();
            popup.setAttribute('data-open', '');
        };

        const closeImagePopup = () => {
            popup.removeAttribute('data-open');
            // app.unlockBody();
        };

        trigger.addEventListener('click', openImagePopup);
        closeTriggers.map(closeTrigger => closeTrigger.addEventListener('click', closeImagePopup));
    }
    
})